import React from "react";

const FaceOffering = () => {
  return (
    <div className="faceHeaderContainer">
      <h2>SCENT’s Exclusive Offerings</h2>
      <h3>Bikini & Brazilian Waxing</h3>
      <p>
        In addition to{" "}
        <a href="https://scentlifestyle.com/face-waxing-detan-threading-salon-in-bangalore">
          face waxing, de-tan, and threading
        </a>
        , SCENT offers exclusive{" "}
        <a href="https://scentlifestyle.com/beauty-essentials">
          Bikini & Brazilian waxing services
        </a>
        . We use peel-off wax or soothing cartridge wax to ensure a comfortable
        and effective hair removal experience.
      </p>
      <h3>Luxurious De-tanning Treatments</h3>
      <p>
        Enhance your skin’s radiance with our{" "}
        <a href="https://scentlifestyle.com/face-waxing-detan-threading-salon-in-bangalore">
          luxurious de-tanning treatments
        </a>
        . These treatments not only remove tan but also hydrate and nourish your
        skin, leaving it glowing and healthy.
      </p>
      <h3>Anti-aging Regimens</h3>
      <p>
        Our anti-aging regimens, featuring mesotherapy and other rejuvenating
        techniques, are designed to combat signs of aging and restore youthful
        vitality to your skin. These treatments are meticulously crafted to
        address your specific skin concerns and deliver remarkable results.
      </p>
    </div>
  );
};

export default FaceOffering;
